import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { FormDefinition } from '../../common/dynamic-form/models/form-definition';
import { Context } from '../../common/dynamic-form/models/context';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DataEntryRenderService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'DataEntryRenderManagement',
      authService,
      config.DERMSConfig
    );
  }

  public async getDefinition(dataEntryId: string): Promise<FormDefinition> {
    return super.get<FormDefinition>(dataEntryId, null, 'definition');
  }

  public async getData(dataEntryId: string): Promise<any> {
    return super.get<any>(dataEntryId, null, 'data');
  }

  public async getDataVersion(dataEntryId: string, version: number): Promise<any> {
    return super.get<any>(dataEntryId, { version: version }, 'data');
  }

  public async getContext(dataEntryId: string): Promise<Context> {
    return super.get<any>(dataEntryId, null, 'context');
  }

  public async getScript(dataEntryId: string): Promise<any> {
    return super.get<any>(dataEntryId, null, 'script');
  }

  public downloadDefinitionXml(dataEntryId: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(dataEntryId) + '/definition/xml', { });
  }

  public downloadDataVersionXml(dataEntryId: string, version: number): Promise<Blob> {
    return this.auth.download(this.buildUrl(dataEntryId) + '/data/xml', { version: version });
  }

  public downloadContextXml(dataEntryId: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(dataEntryId) + '/context/xml', { });
  }

  public downloadDataExport(id: string, version: number): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/download', { version: version });
  }

  public downloadDataExportTemplate(id: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/downloadtemplate', { });
  }

  public upload(id: string, mode: number, files: Set<File>, doneCallback?: (message) => void, errorCallback?: (error) => void): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id) + '/upload/' + mode, files, doneCallback, errorCallback);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry/dataentry.render.service.ts